define('common/views/login/top',['require','glu/model','glu/itemView','hbs!./top.hbs','glu/http','config','app/store','glu/$','app/nav/ForgotPassword','app/models/User','app/nav/ResetPassword','glu/dialog'],function(require) {
	'use strict';

	var Model = require('glu/model'),
		ItemView = require('glu/itemView'),
		tmpl = require('hbs!./top.hbs'),
		http = require('glu/http'),
		config = require('config'),
		sessionStore = require('app/store'),
		$ = require('glu/$'),
		ForgotPasswordView = require('app/nav/ForgotPassword'),
		User = require('app/models/User'),
		ResetPasswordView = require('app/nav/ResetPassword'),
		dialog = require('glu/dialog');

	return ItemView.extend({

		template: tmpl,
		className: 'login floaty-box',
		binding: true,

		initialize: function(options) {
			this.model = new Model();
			this.brandMode = options && options.brandMode;

			this.forgotPasswdView = new ForgotPasswordView({
				model: this.model,
				className: ''
			});

			this.resetPasswdView = new ResetPasswordView({
				model: this.model,
				className: ''
			});

			var url = window.location.href;
			if (url.search('reset-password') > 0) {
				// get the token from the URL and direct to Reset Password Page
				var idx = url.indexOf(config.resetPasswdUrl) + config.resetPasswdUrl.length + 1;

				// token is a uuid with length 36
				var uuidLength = 36;
				var token = url.slice(idx, idx + uuidLength);
				this.resetPasswdView.setToken(token);
				this.$el.toggleClass('is-reset-password-view');
			}
		},

		onRender: function() {
			$('.application-header').remove();
			this.generateForgotPasswordView();
			this.generateResetPasswordView();
		},

		events: {
			'click .btn-submit-login': 'doLogin',
			'click #forgot-password-link': 'toggleForgotPasswordView',
			'click #forgot-back-to-login': 'toggleForgotPasswordView',
			'click #reset-back-to-login': 'toggleResetPasswordView',
		},

		templateHelpers: {
			sessionExpired: function() {
				return true;
			}
		},

		toggleForgotPasswordView: function(e) {
			e.preventDefault();
			this.$el.toggleClass('is-forgot-password-view');
		},

		toggleResetPasswordView: function(e) {
			window.location.href = config.baseUrl;
		},


		generateForgotPasswordView: function() {
			this.forgotPasswdView.render();
			this.$el.find('.forgot-password-view').append(this.forgotPasswdView.render().el);
		},


		generateResetPasswordView: function() {
			this.resetPasswdView.render();
			this.$el.find('.reset-password-view').append(this.resetPasswdView.render().el);
		},

		doLogin: function(evt) {
			evt.preventDefault();
			var self = this;
			var accessedUrl = window.location.pathname;
			$('.btn-submit-login').attr('aria-busy', true);
			http.post(config.apiRoot + 'auth/login', {
				username: self.getUsername(),
				password: self.getPassword()
			}).then(function(token) {

				sessionStore.setApiToken(token);
				sessionStore.setApiUsername(self.getUsername());

				http.setRequestHeaders({
					'API-TOKEN': token
				});

				var user = new User();
				user.fetch().done(function(response) {
					if (response && response.tenantId) {
						try {
							if (ga) {
								ga('send', 'event', response.tenantId, 'login', self.getUsername());
							}
						} catch (err) {
							// do not log the error
						}
					}
				}).then(function() {
					// Attempt a redirect to the page the user tried to directly access

					if (accessedUrl.indexOf('login') === -1 && accessedUrl.indexOf('logout') === -1) {
						window.location.href = accessedUrl;
					} else {
						window.location.href = config.baseUrl;
					}
				});

			}, function(xhr, textStatus, errorThrown) {
				$('.btn-submit-login').attr('aria-busy', false);
				if (xhr.responseText.indexOf('USER_LOCKED') > -1)
					dialog.alert('This account has been temporarily blocked due to too many unsuccessful login attempts.', 'Login failure');
				else
					dialog.alert('Please ensure you have the correct username and password and try again.', 'Login failure');
			});

		},

		getUsername: function() {
			return this.$el.find('#a11y-username').val().toString().toLocaleLowerCase();
		},

		getPassword: function() {
			return this.$el.find('#a11y-password').val();
		},

		serializeData: function() {
			return this;
		}
	});
});

